import { APIModelAttributes } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const modelNamespace = 'model';

export const addModels =
  actionCreator<APIModelAttributes[]>('[model] ADD_MODELS');

export const updateModel = actionCreator<APIModelAttributes>(
  '[model] UPDATE_MODEL'
);

export const resetModels = actionCreator<void>('[model] RESET_MODELS');

export const resetModelsWithData = actionCreator<APIModelAttributes[]>(
  '[model] RESET_MODELS_WITH_PAYLOAD'
);

// Upserts (or, with null, removes) the synthetic virtual model. The real org
// models are kept in sync independently (load + websocket); the virtual model
// is the only one that lives solely on the enhanced scope data.
export const setVirtualModel = actionCreator<APIModelAttributes | null>(
  '[model] SET_VIRTUAL_MODEL'
);
